import gql from 'graphql-tag';

import remoteItemFromProviderFragment from '../fragments/remoteItemFromProviderFragment';

export default gql`
  query remoteItemsFromProviderByRemoteID($remoteID: ID!) {
    remoteItemsFromProviderByRemoteID(remoteID: $remoteID) {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
